  
<div class="container">
    <div class="shadow p-3 mb-5 bg-white rounded">
      <div class="row">
        <div class="card-column" style="width: 8rem;border:0ch">
            <div class="card-body"></div>
         </div>
         <div class="card-column" style="width: 48rem;border:0ch">
            <div class="card-body">
               <img class="card-img-top" src="assets/img/404.png" alt="portada">
            </div>
         </div>
       </div> <!-- Termina div row -->
       <div class="row">
        <div class="card-column" style="width: 28rem;border:0ch">
            <div class="card-body"></div>
         </div>
         <div class="card-column" style="width: 24rem;border:0ch">
            <div class="card-body">
       <button 
       type="button" (click)="inicio();"  class="btn btn-outline-primary ">
       ir al Inicio
     </button>
    </div>
</div>
</div> <!-- Termina div row -->

     </div> <!-- Termina div shadow -->
   </div> <!-- Termina div container-->
   